<template>
    <div>
        <v-main>
            <div class="bg-brand">
                <div class="brand">
                    <div class="logo">
                        <img :src="logo" alt="">
                    </div>
                    <div class="branner">
                        <img :src="branner" alt="">
                    </div>
                </div>

                <div class="action" >
                    <v-container >
                        <div style="display:flex;justify-content:center;padding-bottom: 10px">
                           <h2 >Login or Sign Up</h2>
                        </div>
                        <div style="display:flex;justify-content:center;padding-bottom: 25px">
                            <span>Login or create an account to Be Loyalty</span>
                        </div>
                        <div style="display:flex;justify-content:center;padding-bottom: 15px">
                            <v-btn block color="25388D" style="color:#fff !important;border-radius:20px;text-decoration: none;" to="/select/login">login</v-btn>
                        </div>
                        <div style="display:flex;justify-content:center;">
                            <v-btn block color="#E6E6E6" style="color:#25388D !important;border-radius:20px;text-decoration: none;" to="/signUp">Create an account</v-btn>
                        </div>
                    </v-container>
                </div>
            </div>
        </v-main>
    </div>
</template>

<script>
export default {
  name: 'LoyaltySystemBrand',

  data () {
    return {
      logo: 'https://firebasestorage.googleapis.com/v0/b/img-loyalty.appspot.com/o/Group%20785%20(1).png?alt=media&token=075ae366-ee82-4b94-ab70-19eb5980cac8',
      branner: 'https://firebasestorage.googleapis.com/v0/b/img-loyalty.appspot.com/o/Group%20785.png?alt=media&token=a18bc498-a27a-4377-9106-57416312ac3d'
    }
  },

  mounted () {

  },

  methods: {
    login () {
      window.location = 'http://localhost:8081/select/login'
    },
    Create () {
      window.location = 'http://localhost:8081/signUp'
    }

  }
}
</script>

<style scoped>

/* @media only screen and (max-width: 768px) { */
    .bg-brand {
        background-image: url('https://firebasestorage.googleapis.com/v0/b/img-loyalty.appspot.com/o/1.%20Splash%20Screen.jpg?alt=media&token=494e4197-3a77-46d8-a5dc-73aff40fbd65');
        height: 100vh;
        width: 100%;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        display: flex;
        position: absolute;
        justify-content: center;
    }
    .brand {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .logo  {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 170px;
        height: 150px;
        animation: myAnimation 2s ease-in-out forwards;
        top: 6%;
        position: absolute;
    }
    .logo img {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 140px;
        max-height: 120px;
        animation: myAnimation 2s ease-in-out forwards;

        position: absolute;
    }
    .branner {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top:25%;
    }
    .branner img {
        display: flex;
        justify-content: center;
        max-width: 250px;
        max-height: 230px;
    }
    .action {
        width: 95%;
        height: 294px;
        flex-shrink: 0;
        border-radius: 20px;
        background: var(--neutral-white, #FFF);
        position: absolute;
        bottom: 10px;
        display: flex;
        justify-content: center;

    }
    .title {
        padding-top: 10px;
    }
    .btn-signup {
        display: flex;
        /* width: 311px; */
        padding: 16px 133px;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        /* background: var(--color-primary, #25388D); */
        position: absolute;
        top: 25px;
    }
     .des {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 65px;
    }
    .Login {
        border-radius: 20px;
        /* width: 327px; */
        height: 24px;
        position: absolute;
        top: 85px;
    }
    .create {
        border-radius: 20px;
        width: 327px;
        height: 24px;
        position: absolute;
        top: 155px;
    }
    .v-btn:not(.v-btn--round).v-size--default {
    height: 56px;
    min-width: 64px;
    padding: 0 16px;
    }
/* } */
</style>



// WEBPACK FOOTER //
// src/components/V2LOYALTY_REDESIGN/login.vue